import I18n from "common/i18n";
import { btnDelay, usePlaySound } from "common/utils";

// 追加カードが画面外のときに右下へ表示する FAB。押下で最下部へスクロールする補助動線。
export const AddMapButton = ({ onClick }: { onClick: () => void }) => {
  const play = usePlaySound();

  const handleClick = () => {
    play();
    btnDelay(() => onClick());
  };

  return (
    <div className="absolute bottom-4 right-6 z-20 alpha pointer-events-auto">
      <button
        type="button"
        onClick={handleClick}
        aria-label={I18n.t("MSG_BUILDER_SCROLL_TO_BOTTOM_BTN")}
        className="type-inherit-font btn btn-blue flex-col-center !w-16 !h-16 !p-0 !m-0 !rounded-full"
      >
        <span className="material-symbols-outlined type-hero text-white">arrow_downward</span>
      </button>
    </div>
  );
};
